module.exports = __webpack_public_path__ + "img/MyOrders.26ecee6a.png";